module.exports = __webpack_public_path__ + "static/img/7.cc3285f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/7.png
// module id = 3Z+p
// module chunks = 0